import { initSubRoutes } from '../../../../../utils/router';
import { CEAF } from '../../../../../constants/accessibilite.constants';

const RoutesEditerCeaf = initSubRoutes({
    route: '/editer',
    subroutes: {},
    nom: `Editer une carte européenne d'arme à feu (${CEAF})`,
});

export default RoutesEditerCeaf;
